import React from "react";
import { Bookmark, Command, Edit, Search, Star } from "react-feather";
import { ComponenteFeature } from "../Componentes/indexComponentes";
import { Container } from "../Home/styleHome";
import {
  Container1, Container1Texto,
  Container2,
  ContainerEditais,
  ContainerEditalTexto,
  ContainerHeader,
  Triangulo
} from "../Componentes/styleComponentes";
import { ImagemEdital } from "./styleEditais";
import editaisImagem from "../imagens/editais@2x.png";

import "animate.css/animate.css";

const texto = "Receba diariamente novas oportunidades pré-qualificadas, baixe os editais sem precisar digitar CAPTCHA, qualifique os editais de seu interesse utilizando nosso modo de visualização EXCLUSIVO para prospecção, defina prioridade, atribua para um responsável e/ou empresa e pronto!"
export const Editais = ({ editais }) => {
  return (
    <Container id={"editais"}>
      <ContainerHeader>
        <Container1 background={"#727B84"}>
          <Container1Texto paddingLeft={"100px"} >
            <div style={{ display: "flex" }}>
              <div>
                <Bookmark size={"75px"} color="#d2e2f1" />
              </div>
              <header>
                <span style={{ color: "#e2e2e2" }}>MÓDULO</span>
                <h2>PROSPECÇÃO
                </h2>
              </header>
            </div>
            <div>
              <p>{texto}</p>
            </div>
          </Container1Texto>

          <ImagemEdital scroll={editais}>
            <img
                src={editaisImagem}
                height={"auto"}
                width={"99%"}
                alt={"editais"}
            />
          </ImagemEdital>

        </Container1>
        <Triangulo />
        <Container2>
          <ComponenteFeature
            status={editais}
            titulo={"OPORTUNIDADES DO DIA"}
            subTitulo={"EDITAIS PRÉ-SELECIONADOS DIARIAMENTE"}
            icone={<Edit />}
            texto={
              "Receba novas oportunidades de negócios todos os dias."
            }
          />

          <ComponenteFeature
            status={editais}
            titulo={"PESQUISA AVANÇADA"}
            editais={editais}
            subTitulo={"UTILIZE DIVERSOS FILTROS"}
            icone={<Search />}
            texto={
              "Editais dos principais portais de licitação do Brasil."
            }
          />

          <ComponenteFeature
            status={editais}
            titulo={"DOWNLOAD DIRETO"}
            subTitulo={"SEM DIGITAR CAPTCHA"}
            icone={<Command />}
            texto={
              "Baixe editais dos principais portais sem a necessidade de ficar digitando captchas o tempo todo."
            }
          />
          <ComponenteFeature
            status={editais}
            titulo={"TELA DE PROSPECÇÃO"}
            subTitulo={"MODO DE VISUALIZAÇÃO EXCLUSIVO"}
            icone={<Star />}
            texto={
              "Centralizamos as principais informações do Edital que são indispensáveis para sua decisão. "
            }
          />
        </Container2>
      </ContainerHeader>
    </Container>
  );
};
